import React, { useEffect } from 'react';
import { styled, Placeholder, Container } from '@goodrx/matisse';

import { useSynapse } from 'app/lib/synaptik';
import Markdown from 'app/components/core/markdown';
import { useRouter } from 'next/router';

const MonographWrapper = styled.div`
  max-width: 624px;
  margin: 0 auto;
`;

const DrugInformation: React.FC = () => {
  const {
    query: { ndc, rxcui },
  } = useRouter();

  const [fetchDrugInformation, drugInformation, isFetchingDrugInformation] = useSynapse(({ education }) => [
    education.fetchDrugInformation,
    education.state.drugInformation,
    education.state.fetchingDrugInformation,
  ]);

  useEffect(() => {
    const monographParams = {
      ...(ndc && typeof ndc === 'string' ? { ndc } : {}),
      ...(rxcui && typeof rxcui === 'string' ? { rxcui } : {}),
    };
    fetchDrugInformation(monographParams);
  }, [rxcui, ndc]);

  return (
    <Container>
      <MonographWrapper>
        <Placeholder loading={isFetchingDrugInformation}>
          <Markdown source={drugInformation} />
        </Placeholder>
      </MonographWrapper>
    </Container>
  );
};

export default DrugInformation;
